import axios from "axios";

export function logErrorAction(name, message, stack, isReactError) {
    return {
        type: "LOG_ERROR",
        payload: async () => {
            const data = {
                type: name,
                message: message,
                stack: stack
            };

            if (isReactError !== undefined)
                data.isReactError = isReactError

            const response = await axios.post('/api/v2/log/error', data);

            return response.data;
        }
    };
}

export function logInfoAction(action, bid, metadata) {
    return {
        type: "LOG_INFO",
        payload: async () => {
            const response = await axios.post('/api/v2/log/info', {
                action: action,
                bid: bid,
                metadata: metadata
            });

            return response.data;
        }
    };
}